<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper floatCss"
    >
      <div class="personalData-wrapper floatCss">
        <div class="personalData-header floatCss">
          <b-row>
            <b-col cols="12">
              <div class="pdc-tittle-bar floatCss">
                <div class="pdc-back">
                  <div class="pdc-back-btn">
                    <b-button
                      class="pdc-btn-1"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <div class="pdc-tittle-block">
                    <h3>Terms and conditions</h3>
                  </div>
                </div>
                <div class="pdc-right-block">
                  <h3>{{ transferRequest.lotLocation }} / {{ transferRequest.nvsFileType }} • {{ transferRequest.lotType }}</h3>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="personalData-content floatCss">
          <b-row v-if="transferRequest.transferType === 'ownership'">
            <b-col cols="12">
              <div class="personalData-content-info floatCss">
                <p>I declare that I have read and understood the terms and conditions imposed in relation to the enjoyment of the said cinerary urn compartments / pedestal / funeral service package. I hereby accept the transfer of the said cinerary compartment / pedestal / funeral service package and agree to be bound by all obligations conditions and stipulations imposed in relation to the enjoyment of the same as if I were the purchaser thereof in lieu of the transferor(s) above named.</p>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="12">
              <div class="personalData-content-info floatCss">
                <p>I declare that I have read and understood the terms and conditions imposed in relation to the enjoyment of the said cinerary urn compartments / pedestal / funeral service package. I hereby accept the transfer of the said cinerary compartment / pedestal / funeral service package and agree to be bound by all obligations conditions and stipulations imposed in relation to the enjoyment of the same as if I were the purchaser thereof in lieu of the transferor(s) above named.</p>
                <ol>
                  <li>We refer to the above matter and to the Original Purchaser/Assignor’s purchase of all that license to use the product as set out in <strong class="text-underline">Section 4 of the Schedule</strong> hereto (“<strong>Product</strong>”), the details of which are more particularly described in the Purchase Order made between the Company and the Original Purchaser/Assignor, which particulars as stated in <strong class="text-underline">Section 5 of the Schedule</strong> hereto (“PO”). A copy of the PO is annexed herewith as “<strong>Annexure A</strong>”.</li>
                  <li>We, the undersigned hereby wish to inform you that pursuant to a private arrangement/transaction between the Original Purchaser/Assignor and the New Purchaser/Assignee (“<strong>Private Transaction</strong>”), the Original Purchaser/Assignor has agreed to assign and novate absolutely all his/her/its rights, benefits, interest and obligations in the PO to the New Purchaser/Assignee; and the New Purchaser/Assignee has agreed to accept the assignment and novation of all the covenants, agreements, duties, liabilities, rights and obligations of the Original Purchaser/Assignor under the PO upon the terms and conditions therein contained with effect from the date as more particularly set out in <strong class="text-underline">Section 6 of the Schedule</strong> hereto (“<strong>Effective Date</strong>”).</Li>
                  <li>We hereby confirm and acknowledge that the New Purchaser/Assignee has read the PO and the latest prospectus of the Product and that it has irrevocably and unconditionally agreed to take over and assume all of the obligations, rights, title and interests and benefits of the Original Purchaser/Assignor under or in connection with the PO and shall duly and punctually perform and observe all obligations and discharge all liabilities whatsoever from time to time to be performed or discharged by the Original Purchaser/Assignor under or in connection with the PO and to be bound by all the terms and conditions and stipulations contained in the PO to be performed and/or observed by the Original Purchaser/Assignor with effect from the Effective Date.</Li>
                  <li>
                    Following from the above, we hereby irrevocably and unconditionally agree and confirm that with effect from the Effective Date:-
                    <ol>
                      <li>the Original Purchaser/Assignor shall cease to be a party to the PO and the New Purchaser/Assignee shall become a party to it in place of the Original Purchaser/Assignor but the Original Purchaser/Assignor shall remain liable and be bound by all its covenants, agreements, duties, liabilities, obligations, rights, title and interest under and in relation to the Private Transaction.</li>
                      <li>all moneys (including but not limited to the booking fee and purchase price) paid by the Original Purchaser/Assignor to the Company pursuant to the PO shall be treated as moneys paid by the New Purchaser/Assignee to the Company under the PO and the Company shall hold the same for the benefit of the New Purchaser/Assignee;</li>
                      <li>the Original Purchaser/Assignor shall have no rights, title, interest, claim or anything whatsoever under the PO and in and to the Product or any part thereof and shall make no claim whatsoever in respect thereof as against the Company;</li>
                      <li>the New Purchaser/Assignee is the person entitled to the rights, title, interest and benefits under and pursuant to the PO and the Product;</li>
                      <li>the intended user for the Product shall be replaced with the person whose name and particulars are as described in <strong class="text-underline">Section 7 of the Schedule</strong> hereto (hereinafter referred to as “<strong>Intended User”</strong>); and</li>
                      <li>All the covenants, provisions, liabilities and powers contained in or subsisting under the PO subject to the novation and assignment effected herein (unless otherwise amended and/or varied with the written consent of the Company) shall continue to be applicable and shall remain in full force and effect from and after the Effective Date.</li>
                    </ol>
                  </Li>
                  <li>The New Purchaser/Assignee hereby acknowledges and declares that it has read and inspected the Company’s Personal Data Protection Notice (“<strong>PDPA Notice</strong>”), and hereby consents to the Company to process its personal data in accordance with the purposes as set out in the PDPA Notice. The New Purchaser/Assignee hereby further warrants and represents to the Company that it had obtained consent from the Intended User to disclose its personal data to the Company for the purposes set out in the PDPA Notice.</li>
                  <li>We hereby further confirm and acknowledge that the Company is not a party to the Private Transaction and that the terms and conditions contained therein the Private Transaction shall not bind the Company.</li>
                  <li>
                    We hereby jointly and severally undertake to indemnify and keep indemnified the Company against all actions, proceedings, claims, loss and expense whatsoever that may be made against and/or suffered by the Company as a result of and/or in connection with:-
                    <ol class="lower-alpha-list">
                      <li>any breach of the terms, covenants and stipulations in the PO to be performed and observed by the Original Purchaser/Assignor prior to the Effective Date; and/or</li>
                      <li>any failure on the part of the New Purchaser/Assignee to perform and/or observe the terms, covenants and stipulations in the PO from and after the Effective Date; and/or</li>
                      <li>the Original Purchaser/Assignor shall have no rights, title, interest, claim or anything whatsoever under the PO and in and to the Product or any part thereof and shall make no claim whatsoever in respect thereof as against the Company;</li>
                      <li>any breach of the terms, covenants and stipulations in this Notice of Assignment cum Novation by the Original Purchaser/Assignor and/or the New Purchaser/Assignee.</li>
                    </ol>
                  </li>
                  <li>Unless the context otherwise requires, words denoting the singular shall include the plural and vice versa and words importing the masculine gender shall be deemed to include the feminine and neuter genders and vice versa.</li>
                </ol>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pdc-check-wrapper ct-checkbox floatCss">
                <div class="rv-single-input floatCss">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="status"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    Yes, I agree
                  </b-form-checkbox>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="Purchaserdetails-bottom pdc-bottom floatCss">
        <b-row>
          <b-col cols="12">
            <b-button
              class="pr-btn-2"
              :disabled="status == 'not_accepted'"
              @click="savePersonalDataConsent"
            >
              Save terms and conditions
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    AppLoader,
  },
  data() {
    return {
      sameAsCorrespondence: true,
      showMessage: false,
      tokenDetail: {},
      transferRequest: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      status: 'not_accepted',
    }
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.packageName = response.data.packageName
              if (this.transferRequest.currentStatus === 'Pending NP') {
                this.showMessage = true
                this.status = this.transferRequest.termsConsent ? 'accepted' : 'not_accepted'
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'You have already completed this step',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    savePersonalDataConsent() {
      localStorage.setItem('fileTransferDraft_terms', JSON.stringify({ status: this.status }))
      this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
    },
  },
}
</script>

<style lang="scss">
  .text-underline {
    text-decoration: underline;
  }
</style>
